

const PesquisarHistoricoFiltroController = ControllerBase.extend({
    name: "PesquisarHistoricoFiltroController",
    initialize: function () {
        this._id = 0;
        if (this.model && this.model.attributes && this.model.get("Id") != null)
            this._id = this.model.get("Id");
        if (this.params) {
            this._VendedorId = this.params.CodVendedor;
            this._CodigoCliente = this.params.CodigoCliente;
        } else {
            this._VendedorId = null;
            this._CodigoCliente = null; 
        }
    },
    ajax: function() {
        return { 
            url: "/Produto/_HistoricoFiltro",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                idFiltro: this._id,
                vendedorId: this._VendedorId,
                codigoCliente: this._CodigoCliente,
                checkFiltrarCliente: this.params.checkFiltroCliente
            })
        };
    },

    renderizado: function () {

       
        this.HistoricoFiltroView = this.showView({
            region: {
                name: "historicoFiltroViewRegion",
                selector: "#pesquisar-historico-filtros-region"
            },
            view: {
                type: HistoricoFiltroView,
                args: {
                    collection: new HistoricosFiltros(this.model),
                    controller: this
                }
            }
        });
        (this.params.checkFiltroCliente === undefined) ? false : $('input[name=FiltrarCliente]').prop('checked', this.params.checkFiltroCliente);
        if (this._CodigoCliente == null) {
            $("#HistoricoFiltro_FiltrarCliente").parent().hide();
        }
        else {
            $("#HistoricoFiltro_FiltrarCliente").parent().show();
        }
    },

    pesquisarHistoricoFiltro: function () {

        this.historicoFiltroController = this.showView({
            region: {
                name: "historicoFiltroControllerRegion",
                selector: "#pesquisar-historico-filtro-container"
            },
            controller: {
                type: PesquisarHistoricoFiltroController,
                args: {
                    controllerPai: this.controller,
                    model: this.model,
                    params: {
                        CodVendedor: this._VendedorId,
                        CodigoCliente: this._CodigoCliente,
                        checkFiltroCliente: $('input[name=FiltrarCliente]').prop('checked')
                    }
                }
            }
        });
    },

    fixarItem: function(modelItem) {
        console.log(modelItem)

        this.historicoFiltroController = this.showView({
            region: {
                name: "historicoFiltroControllerRegion",
                selector: "#pesquisar-historico-filtro-container"
            },
            controller: {
                type: PesquisarHistoricoFiltroController,
                args: {
                    controllerPai: this.controller,
                    model: modelItem,
                    params: {
                        CodVendedor: this._VendedorId,
                        CodigoCliente: this._CodigoCliente,
                        checkFiltroCliente: this.params.checkFiltroCliente
                    }
                }
            }
        });
    },
    desafixarItem: function(modelItem) {

        this.historicoFiltroController = this.showView({
            region: {
                name: "historicoFiltroControllerRegion",
                selector: "#pesquisar-historico-filtro-container"
            },
            controller: {
                type: PesquisarHistoricoFiltroController,
                args: {
                    controllerPai: this.controller,
                    model: modelItem,
                    params: {
                        CodVendedor: this._VendedorId,
                        CodigoCliente: this._CodigoCliente,
                        checkFiltroCliente: this.params.checkFiltroCliente
                    }
                }
            }
        });
    }
})

window.PesquisarHistoricoFiltroController = PesquisarHistoricoFiltroController

export {
    PesquisarHistoricoFiltroController
}

